export function formatAddress(
  country: string,
  state: string,
  city: string,
  address: string,
  postalCode: string
) {
  // const parts = []
  // parts.push(address)
  // parts.push(city)
  // parts.push(state)
  // parts.push(country)
  // parts.push(postalCode)
  return {
    address1: address,
    postalCode: postalCode,
    city: city,
    stateAbbreviation: state,
    countryAbbreviation: country
  }
  // return parts.join(' ')
}

export const countryCodes = [
  {
    name: 'North America',
    countries: [
      {
        name: 'United States',
        code: '+1'
      },
      {
        name: 'Canada',
        code: '+1'
      },
      {
        name: 'Anguilla',
        code: '+1264'
      },
      {
        name: 'Antigua and Barbuda',
        code: '+1268'
      },
      {
        name: 'Aruba',
        code: '+297'
      },
      {
        name: 'Ascension',
        code: '+247'
      },
      {
        name: 'Bahamas',
        code: '+1242'
      },
      {
        name: 'Barbados',
        code: '+1246'
      },
      {
        name: 'Belize',
        code: '+501'
      },
      {
        name: 'Bermuda',
        code: '+1441'
      },

      {
        name: 'Cayman Islands',
        code: '+1345'
      },
      {
        name: 'Costa Rica',
        code: '+506'
      },
      {
        name: 'Cuba',
        code: '+53'
      },
      {
        name: 'Curaçao and Caribbean Netherlands',
        code: '+599'
      },
      {
        name: 'Dominica',
        code: '+1767'
      },
      {
        name: 'Dominican Republic',
        code: '+1829'
      },
      {
        name: 'Dominican Republic',
        code: '+1849'
      },
      {
        name: 'Dominican Republic',
        code: '+1809201'
      },
      {
        name: 'Dominican Republic',
        code: '+1809'
      },
      {
        name: 'El Salvador',
        code: '+503'
      },
      {
        name: 'Greenland',
        code: '+299'
      },
      {
        name: 'Grenada',
        code: '+1473'
      },
      {
        name: 'Guadeloupe',
        code: '+590'
      },
      {
        name: 'Guatemala',
        code: '+502'
      },
      {
        name: 'Haiti',
        code: '+509'
      },
      {
        name: 'Honduras',
        code: '+504'
      },
      {
        name: 'Jamaica',
        code: '+1876'
      },
      {
        name: 'Jamaica',
        code: '+1658'
      },
      {
        name: 'Martinique',
        code: '+596'
      },
      {
        name: 'Mexico',
        code: '+52'
      },
      {
        name: 'Montserrat',
        code: '+1664'
      },
      {
        name: 'Nicaragua',
        code: '+505'
      },
      {
        name: 'Panama',
        code: '+507'
      },
      {
        name: 'Puerto Rico',
        code: '+1787'
      },
      {
        name: 'St Kitts and Nevis',
        code: '+1869'
      },
      {
        name: 'St Lucia',
        code: '+1758'
      },
      {
        name: 'St Pierre and Miquelon',
        code: '+508'
      },
      {
        name: 'St Vincent Grenadines',
        code: '+1784'
      },
      {
        name: 'Trinidad and Tobago',
        code: '+1868'
      },
      {
        name: 'Turks and Caicos Islands',
        code: '+1649'
      },
      {
        name: 'Virgin Islands, British',
        code: '+1284'
      },
      {
        name: 'Virgin Islands, U.S.',
        code: '+1340'
      }
    ]
  },
  {
    name: 'Asia',
    countries: [
      {
        name: 'Afghanistan',
        code: '+93'
      },
      {
        name: 'Armenia',
        code: '+374'
      },
      {
        name: 'Bahrain',
        code: '+973'
      },
      {
        name: 'Bhutan',
        code: '+975'
      },
      {
        name: 'Brunei',
        code: '+673'
      },
      {
        name: 'Cambodia',
        code: '+855'
      },
      {
        name: 'China',
        code: '+86'
      },
      {
        name: 'East Timor',
        code: '+670'
      },
      {
        name: 'Georgia',
        code: '+995'
      },
      {
        name: 'Hong Kong',
        code: '+852'
      },
      {
        name: 'India',
        code: '+91'
      },
      {
        name: 'Indonesia',
        code: '+62'
      },
      {
        name: 'Iran',
        code: '+98'
      },
      {
        name: 'Iraq',
        code: '+964'
      },
      {
        name: 'Japan',
        code: '+81'
      },
      {
        name: 'Jordan',
        code: '+962'
      },
      {
        name: "Korea Dem People's Rep",
        code: '+850'
      },
      {
        name: 'Korea Republic of',
        code: '+82'
      },
      {
        name: 'Kuwait',
        code: '+965'
      },
      {
        name: 'Kyrgyzstan',
        code: '+996'
      },
      {
        name: 'Laos PDR',
        code: '+856'
      },
      {
        name: 'Lebanon',
        code: '+961'
      },
      {
        name: 'Macau',
        code: '+853'
      },
      {
        name: 'Malaysia',
        code: '+60'
      },
      {
        name: 'Maldives',
        code: '+960'
      },
      {
        name: 'Mongolia',
        code: '+976'
      },
      {
        name: 'Myanmar',
        code: '+95'
      },
      {
        name: 'Nepal',
        code: '+977'
      },
      {
        name: 'Philippines',
        code: '+63'
      },
      {
        name: 'Qatar',
        code: '+974'
      },
      {
        name: 'Russia/Kazakhstan',
        code: '+7'
      },
      {
        name: 'Saudi Arabia',
        code: '+966'
      },
      {
        name: 'Singapore',
        code: '+65'
      },
      {
        name: 'Syria',
        code: '+963'
      },
      {
        name: 'Taiwan',
        code: '+886'
      },
      {
        name: 'Thailand',
        code: '+66'
      },
      {
        name: 'Turkiye',
        code: '+90'
      },
      {
        name: 'Turkmenistan',
        code: '+993'
      },
      {
        name: 'United Arab Emirates',
        code: '+971'
      },
      {
        name: 'Uzbekistan',
        code: '+998'
      },
      {
        name: 'Vietnam',
        code: '+84'
      },
      {
        name: 'Yemen',
        code: '+967'
      }
    ]
  },
  {
    name: 'Europe',
    countries: [
      {
        name: 'Albania',
        code: '+355'
      },
      {
        name: 'Andorra',
        code: '+376'
      },
      {
        name: 'Austria',
        code: '+43'
      },
      {
        name: 'Belarus',
        code: '+375'
      },
      {
        name: 'Belgium',
        code: '+32'
      },
      {
        name: 'Bosnia and Herzegovina',
        code: '+387'
      },
      {
        name: 'Bulgaria',
        code: '+359'
      },
      {
        name: 'Canary Islands',
        code: '+3491'
      },
      {
        name: 'Croatia',
        code: '+385'
      },
      {
        name: 'Cyprus',
        code: '+357'
      },
      {
        name: 'Czech Republic',
        code: '+420'
      },
      {
        name: 'Denmark',
        code: '+45'
      },
      {
        name: 'Estonia',
        code: '+372'
      },
      {
        name: 'Faroe Islands',
        code: '+298'
      },
      {
        name: 'Finland/Aland Islands',
        code: '+358'
      },
      {
        name: 'France',
        code: '+33'
      },
      {
        name: 'Germany',
        code: '+49'
      },
      {
        name: 'Gibraltar',
        code: '+350'
      },
      {
        name: 'Greece',
        code: '+30'
      },
      {
        name: 'Guernsey/Jersey',
        code: '+44'
      },
      {
        name: 'Hungary',
        code: '+36'
      },
      {
        name: 'Iceland',
        code: '+354'
      },
      {
        name: 'Ireland',
        code: '+353'
      },
      {
        name: 'Isle of Man',
        code: '+44'
      },
      {
        name: 'Italy',
        code: '+39'
      },
      {
        name: 'Kosovo',
        code: '+383'
      },
      {
        name: 'Latvia',
        code: '+371'
      },
      {
        name: 'Liechtenstein',
        code: '+423'
      },
      {
        name: 'Lithuania',
        code: '+370'
      },
      {
        name: 'Luxembourg',
        code: '+352'
      },
      {
        name: 'Malta',
        code: '+356'
      },
      {
        name: 'Moldova',
        code: '+373'
      },
      {
        name: 'Monaco',
        code: '+377'
      },
      {
        name: 'Montenegro',
        code: '+382'
      },
      {
        name: 'Netherlands',
        code: '+31'
      },
      {
        name: 'Norway',
        code: '+47'
      },
      {
        name: 'Poland',
        code: '+48'
      },
      {
        name: 'Portugal',
        code: '+351'
      },
      {
        name: 'Republic of North Macedonia',
        code: '+389'
      },
      {
        name: 'Romania',
        code: '+40'
      },
      {
        name: 'San Marino',
        code: '+378'
      },
      {
        name: 'Serbia',
        code: '+381'
      },
      {
        name: 'Slovakia',
        code: '+421'
      },
      {
        name: 'Slovenia',
        code: '+386'
      },
      {
        name: 'Spain',
        code: '+34'
      },
      {
        name: 'Sweden',
        code: '+46'
      },
      {
        name: 'Switzerland',
        code: '+41'
      },
      {
        name: 'Turkish Republic of Northern Cyprus',
        code: '+90'
      },
      {
        name: 'Ukraine',
        code: '+380'
      },
      {
        name: 'United Kingdom',
        code: '+44'
      },
      {
        name: 'Vatican City',
        code: '+379'
      }
    ]
  },
  {
    name: 'South America',
    countries: [
      {
        name: 'Argentina',
        code: '+54'
      },
      {
        name: 'Bolivia',
        code: '+591'
      },
      {
        name: 'Brazil',
        code: '+55'
      },
      {
        name: 'Chile',
        code: '+56'
      },
      {
        name: 'Colombia',
        code: '+57'
      },
      {
        name: 'Ecuador',
        code: '+593'
      },
      {
        name: 'Falkland Islands',
        code: '+500'
      },
      {
        name: 'French Guiana',
        code: '+594'
      },
      {
        name: 'Guyana',
        code: '+592'
      },
      {
        name: 'Paraguay',
        code: '+595'
      },
      {
        name: 'Peru',
        code: '+51'
      },
      {
        name: 'Suriname',
        code: '+597'
      },
      {
        name: 'Uruguay',
        code: '+598'
      },
      {
        name: 'Venezuela',
        code: '+58'
      }
    ]
  },
  {
    name: 'Africa',
    countries: [
      {
        name: 'Angola',
        code: '+244'
      },
      {
        name: 'Benin',
        code: '+229'
      },
      {
        name: 'Botswana',
        code: '+267'
      },
      {
        name: 'Burkina Faso',
        code: '+226'
      },
      {
        name: 'Burundi',
        code: '+257'
      },
      {
        name: 'Cameroon',
        code: '+237'
      },
      {
        name: 'Cape Verde',
        code: '+238'
      },
      {
        name: 'Central Africa',
        code: '+236'
      },
      {
        name: 'Chad',
        code: '+235'
      },
      {
        name: 'Comoros',
        code: '+269'
      },
      {
        name: 'Congo',
        code: '+242'
      },
      {
        name: 'Congo, Dem Rep',
        code: '+243'
      },
      {
        name: 'Djibouti',
        code: '+253'
      },
      {
        name: 'Egypt',
        code: '+20'
      },
      {
        name: 'Equatorial Guinea',
        code: '+240'
      },
      {
        name: 'Eritrea',
        code: '+291'
      },
      {
        name: 'Ethiopia',
        code: '+251'
      },
      {
        name: 'Gabon',
        code: '+241'
      },
      {
        name: 'Gambia',
        code: '+220'
      },
      {
        name: 'Ghana',
        code: '+233'
      },
      {
        name: 'Guinea',
        code: '+224'
      },
      {
        name: 'Guinea-Bissau',
        code: '+245'
      },
      {
        name: 'Ivory Coast',
        code: '+225'
      },
      {
        name: 'Kenya',
        code: '+254'
      },
      {
        name: 'Lesotho',
        code: '+266'
      },
      {
        name: 'Liberia',
        code: '+231'
      },
      {
        name: 'Libya',
        code: '+218'
      },
      {
        name: 'Madagascar',
        code: '+261'
      },
      {
        name: 'Malawi',
        code: '+265'
      },
      {
        name: 'Mali',
        code: '+223'
      },
      {
        name: 'Mauritania',
        code: '+222'
      },
      {
        name: 'Mauritius',
        code: '+230'
      },
      {
        name: 'Morocco/Western Sahara',
        code: '+212'
      },
      {
        name: 'Mozambique',
        code: '+258'
      },
      {
        name: 'Namibia',
        code: '+264'
      },
      {
        name: 'Niger',
        code: '+227'
      },
      {
        name: 'Nigeria',
        code: '+234'
      },
      {
        name: 'Reunion/Mayotte',
        code: '+262'
      },
      {
        name: 'Rwanda',
        code: '+250'
      },
      {
        name: 'Sao Tome and Principe',
        code: '+239'
      },
      {
        name: 'Senegal',
        code: '+221'
      },
      {
        name: 'Seychelles',
        code: '+248'
      },
      {
        name: 'Sierra Leone',
        code: '+232'
      },
      {
        name: 'Somalia',
        code: '+252'
      },
      {
        name: 'South Africa',
        code: '+27'
      },
      {
        name: 'South Sudan',
        code: '+211'
      },
      {
        name: 'Sudan',
        code: '+249'
      },
      {
        name: 'Swaziland',
        code: '+268'
      },
      {
        name: 'Tanzania',
        code: '+255'
      },
      {
        name: 'Togo',
        code: '+228'
      },
      {
        name: 'Uganda',
        code: '+256'
      },
      {
        name: 'Zambia',
        code: '+260'
      },
      {
        name: 'Zimbabwe',
        code: '+263'
      }
    ]
  },
  {
    name: 'Oceania',
    countries: [
      {
        name: 'American Samoa',
        code: '+1684'
      },
      {
        name: 'Australia/Cocos/Christmas Island',
        code: '+61'
      },
      {
        name: 'Cook Islands',
        code: '+682'
      },
      {
        name: 'Fiji',
        code: '+679'
      },
      {
        name: 'French Polynesia',
        code: '+689'
      },
      {
        name: 'Guam',
        code: '+1671'
      },
      {
        name: 'Kiribati',
        code: '+686'
      },
      {
        name: 'Marshall Islands',
        code: '+692'
      },
      {
        name: 'Micronesia',
        code: '+691'
      },
      {
        name: 'New Caledonia',
        code: '+687'
      },
      {
        name: 'New Zealand',
        code: '+64'
      },
      {
        name: 'Niue',
        code: '+683'
      },
      {
        name: 'Norfolk Island',
        code: '+672'
      },
      {
        name: 'Northern Mariana Islands',
        code: '+1670'
      },
      {
        name: 'Palau',
        code: '+680'
      },
      {
        name: 'Papua New Guinea',
        code: '+675'
      },
      {
        name: 'Samoa',
        code: '+685'
      },
      {
        name: 'Solomon Islands',
        code: '+677'
      },
      {
        name: 'Tonga',
        code: '+676'
      },
      {
        name: 'Tuvalu',
        code: '+688'
      },
      {
        name: 'Vanuatu',
        code: '+678'
      },
      {
        name: 'Wallis and Futuna',
        code: '+681'
      }
    ]
  }
]
